import Image from 'next/image';

// Constants
import { IMAGES } from '@/constants/image';

// Utils
import { combineClasses } from '@shared/utils';
interface ThinkingIndicatorProps {
  message?: string;
  className?: string;
}
export const ThinkingIndicator = ({
  message = 'Agility Flash is thinking',
  className
}: ThinkingIndicatorProps) => <div className={combineClasses('flex flex-col items-start px-4 py-1', className)} data-sentry-component="ThinkingIndicator" data-sentry-source-file="ThinkingIndicator.tsx">
    <div className="flex items-center gap-2 border border-frost-250 rounded-lg shadow-md p-4 relative overflow-hidden w-full">
      <div className="flex-shrink-0 relative size-10">
        <div className={combineClasses('size-10 rounded-full flex-center relative m-auto', 'bg-gradient-to-br from-primary-50 to-primary-100 ')}>
          <Image unoptimized src={IMAGES.CHATBOT_PROCESSING} alt="Agility Flash" width={28} height={28} className="size-7 object-contain" data-sentry-element="Image" data-sentry-source-file="ThinkingIndicator.tsx" />
        </div>
      </div>
      <p className="text-4xs text-gray-500">{message}</p>
      <div className="flex gap-1">
        <div className="w-1 h-1 bg-blue-500 rounded-full animate-bounce" style={{
        animationDelay: '0ms'
      }} />
        <div className="w-1 h-1 bg-blue-500 rounded-full animate-bounce" style={{
        animationDelay: '150ms'
      }} />
        <div className="w-1 h-1 bg-blue-500 rounded-full animate-bounce" style={{
        animationDelay: '300ms'
      }} />
      </div>
    </div>
  </div>;